import styled from 'styled-components';
import { makeStyles } from '@material-ui/core';

import appTheme from '../../../../themes/Theme';
import { Color } from '../../../../constants/Color';

export const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledWrapTextField = styled.div`
  /* background-color: white; */
  border-radius: 4px;
  padding: 0 8px;
  margin-bottom: 8px;

  .MuiOutlinedInput-notchedOutline {
    border-color: ${Color.Primary};
  }

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline{
    border-color: ${Color.Primary};

    .PrivateNotchedOutline-legendLabelled-10 > span {
      color: ${Color.Primary}!important;
    }
  }

  input.MuiInputBase-input.MuiOutlinedInput-input::placeholder {
    color: white;
  }

  input.MuiInputBase-input.MuiOutlinedInput-input {
    color: ${appTheme.textColor};
  }

  .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-fullWidth.MuiInputBase-formControl:hover {
    border-color: ${Color.Primary};
  }
`;

export const StyledWrapButton = styled.div`
  padding: 0 8px;
`;

export const WrapTextContent = styled.div`
  color: ${appTheme.textColor};

  p {
    color: ${appTheme.textColor};
  }

  a {
    color: ${appTheme.textColor};
  }
`;

export const useInputStyles = makeStyles({
  root: {
    '&::placeholder': {
      color: 'red',
    }
  }
})
